import React, {
  Component
} from "react";
import {
  connect
} from "react-redux";
import _ from "lodash";
import { Rect, Group, Shape } from "react-konva";
import { InchUtility } from "../../../lib/pipe-dataset";
import { pipeBedSelectElement } from "../../../actions/pipe-bed-actions";
import { renderAccessoryHelper } from "./pipe-accessory-helper";
import FlowArrowComponent from "./flow-arrow-component";

class ManifoldCornerComponent extends Component {
  handleOnMouseOver = (e) => {
    if (this.isSelected()) return;
    e.target.to({
      opacity: 1
    })
  };

  handleOnMouseOut = (e) => {
    if (this.isSelected()) return;
    e.target.to({
      opacity: 0
    })
  };
  handleOnMouseClick = (e) => {
    this.props.pipeBedSelectElement(this.props.id);
  };
  isSelected = () => {
    return _.isEqual(this.props.id, this.props.selected)
  }
  renderAccessories = () => {
    return renderAccessoryHelper({
      ...this.props.id,
      width: this.props.cornerWidth,
      height: this.props.manifoldRowHeight
    }, this.props.pipeElements.find((e) => {
      return _.isEqual(this.props.id, e.id);
    }) || {});
  }

  renderCornerLeg = () => {
    const imgUrl = require('../../../media/pipes/PIPE_PITCH_180x48.png');
    const fragmentImg = new window.Image();
    fragmentImg.src = imgUrl;
    const fillPatternScale = this.props.pipeOD / 180;

    return (<React.Fragment>
      <Shape
        sceneFunc={(context, shape) => {
          context.beginPath();
          context.moveTo(0, 0);
          context.lineTo(this.props.cornerWidth, 0);
          context.lineTo(this.props.cornerWidth, this.props.pipeOD);
          context.lineTo(this.props.pipeOD, this.props.pipeOD);
          context.closePath();
          context.fillStrokeShape(shape);
        }}
        fillPatternImage={fragmentImg}
        fillPatternScaleX={fillPatternScale}
        fillPatternScaleY={fillPatternScale}
        fillPatternRotation={270}
      />
      <Shape
        sceneFunc={(context, shape) => {
          context.beginPath();
          context.moveTo(0, 0);
          context.lineTo(this.props.pipeOD, this.props.pipeOD);
          context.lineTo(this.props.pipeOD, this.props.manifoldRowHeight);
          context.lineTo(0, this.props.manifoldRowHeight);
          context.closePath();
          context.fillStrokeShape(shape);
        }}
        fillPatternImage={fragmentImg}
        fillPatternScaleX={fillPatternScale}
        fillPatternScaleY={fillPatternScale}
      />
      <FlowArrowComponent arrowOrientation={this.props.arrowOrientation.vertical}
        y={this.props.manifoldRowHeight - this.props.pipeOD} />
    </React.Fragment>);
  };

  get pipeODOffset() {
    return this.props.pipeOD * 0.07
  }

  render() {
    let { scaleX, scaleY, rotation, accessoryScaleX, accessoryScaleY, accessoryRotation } = this.props;

    scaleX = !scaleX ? 1 : scaleX;
    scaleY = !scaleY ? 1 : scaleY;
    rotation = !rotation ? 0 : rotation;
    accessoryScaleX = !accessoryScaleX ? 1 : accessoryScaleX;
    accessoryScaleY = !accessoryScaleY ? 1 : accessoryScaleY;
    accessoryRotation = !accessoryRotation ? 0 : accessoryRotation;

    return (
      <Group
      >
        <Group
          x={this.props.x}
          y={this.props.y}
          width={this.props.cornerWidth}
          height={this.props.manifoldRowHeight}
          rotation={rotation}
          scaleX={scaleX}
          scaleY={scaleY}
        >
          {/*manifold outlet*/}
          {this.renderCornerLeg()}
          <Shape
            sceneFunc={(context, shape) => {
              context.beginPath();
              context.moveTo(this.pipeODOffset, this.pipeODOffset);
              context.lineTo(this.props.pipeOD - this.pipeODOffset, this.props.pipeOD - this.pipeODOffset);
              context.fillStrokeShape(shape);
            }}
            stroke="grey"
            strokeWidth={0.5}
          />
          {/*manifold frame useful for debugging*/}
          {/*<Rect*/}
          {/*x={0}*/}
          {/*y={0}*/}
          {/*width={this.props.cornerWidth}*/}
          {/*height={this.props.manifoldRowHeight}*/}
          {/*stroke="red"*/}
          {/*strokeWidth={0.3}*/}
          {/*/>*/}
          {/*manifold selector*/}
          <Rect
            x={0}
            y={0}
            width={this.props.cornerWidth}
            height={this.props.manifoldRowHeight}
            fill={this.isSelected() ? 'rgba(255, 165,0,0.5)' : 'rgba(255,255,255,0.2)'}
            opacity={this.isSelected() ? 1 : 0}
            onMouseOver={this.handleOnMouseOver}
            onMouseOut={this.handleOnMouseOut}
            onClick={this.handleOnMouseClick}
            stroke={'purple'}
            strokeWidth={.4}
            dash={[3, 3]}
          />
        </Group>
        <Group
          rotation={accessoryRotation}
          scaleX={accessoryScaleX}
          scaleY={accessoryScaleY}
          x={this.props.x}
          y={this.props.y}
        >
          {this.renderAccessories()}
        </Group>
      </Group>
    );
  }
}

const mapStateToProps = state => {
  return {
    //...
    pipeOD: state.pipeGlobals.pipeNominalDiameter.pipeOD.px,
    bedWidth: state.pipeBed.pipeBedDimensions.width.px,
    perimeterOffset: new InchUtility(state.pipeGlobals.pipePerimeterOffset),
    manifoldRowHeight: state.pipeGlobals.pipeNominalDiameter.horizontalRowHeight.px,
    numberOfPipeRows: state.pipeBed.numberOfPipeRows,
    rowSpacing: new InchUtility(state.pipeBed.rowSpacing),
    selected: state.pipeGlobals.contextSelectedPipeElement,
    pipeElements: state.pipeBed.pipeElements
  };
};
export default connect(
  mapStateToProps, {
  pipeBedSelectElement
}
)(ManifoldCornerComponent);



// WEBPACK FOOTER //
// ./src/components/Drawings/Pipes/manifold-corner-component.js